import { useSelector } from "react-redux";
import { State } from "../../../state/store";
import { CareRecipient } from "../../../domain/care_recipient/CareRecipient";
import { useMemo } from "react";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { CareRecipientName } from "../../../domain/care_recipient/CareRecipientName";
import { CareRecipientHouseId } from "../../../domain/care_recipient/CareRecipientHouseId";
import { DateObject } from "../../../domain/fundamental/DateObject";
import { CustomerCode } from "../../../domain/care_recipient/CustomerCode";
import { BranchCode } from "../../../domain/care_recipient/BranchCode";

export function useSelectedCareRecipient(): ReturnType {

    const selectedCareRecipientJson = useSelector((state: State) => state.careRecipient.selectedCareRecipient);

    return useMemo(() => {
        if (!selectedCareRecipientJson) return null;
        const careRecipient = CareRecipient.from(
            CareRecipientId.fromString(selectedCareRecipientJson.id),
            CareRecipientName.fromString(selectedCareRecipientJson.name),
            null,
            selectedCareRecipientJson.houseId ? CareRecipientHouseId.fromString(selectedCareRecipientJson.houseId) : null,
            selectedCareRecipientJson.customerCode ? CustomerCode.fromString(selectedCareRecipientJson.customerCode) : null,
            selectedCareRecipientJson.branchCode ? BranchCode.fromString(selectedCareRecipientJson.branchCode) : null,
        );
        return {
            ...careRecipient,
            alertPeriod: selectedCareRecipientJson.alertPeriod ? {
                start: DateObject.fromString(selectedCareRecipientJson.alertPeriod.start),
                end: DateObject.fromString(selectedCareRecipientJson.alertPeriod.end),
            } : null
        };
    }, [selectedCareRecipientJson]);
}

type ReturnType = CareRecipient & { alertPeriod: { start: DateObject, end: DateObject } | null } | null;
